import { Injectable } from '@angular/core';
import {Buffer} from 'buffer';
import { UtilityService } from './utility.service';
import * as pako  from 'pako';


@Injectable()
export class HTMLCompressionService {
    utilityService: UtilityService;

    async compressAndEncodeHTML(htmlContent: string): Promise<string> {
        const origData = htmlContent;
       // const encodedData = (new TextEncoder().encode(origData)).toString();
       // console.log("my encodedData sent to gzip:")
       // console.log(encodedData)
        const compressedData = pako.deflate(htmlContent);
    
        //gzip(encodedData);
        const compressedArray = Array.from(compressedData);
        const base64Data = btoa(String.fromCharCode.apply(null, compressedArray));

        console.log("my compressed data sent to url:")
        console.log(base64Data);
        //const compressedData = await this.utilityService.promisify(gzip(origData));
        //const encodedData = btoa(Buffer.from(compressedData).toString());
        //UtilityService
        return base64Data;
    }

    //async decodeAndDecompressHTML(encodedData: string): Promise<string> {
        //const compressedData = Buffer.from(encodedData, 'base64');
        //const compressedData = pako.inflate(encodedData);
        //const compressedArray = Array.from(compressedData);

        //const decompressedData =ungzip(new Uint8Array(compressedArray));
        //  await this.utilityService.promisify(gunzip(compressedData));
        // const decompressedData = await this.utilityService.promisify(gunzip(compressedData));
       // return decompressedData.toString();
   // }
}
